export default "__VITE_ASSET__Csudk2oq__"